const keyPrefix = "c260205_";

const maskImages = {
    "1_1": {
        filter: [ "./images/mask/1_1/filter_001.png", "./images/mask/1_1/filter_002.png", "./images/mask/1_1/filter_003.png"],
        point: [ { x: 118, y: 90 },
                 { x: 143, y: 120 },
                 { x: 110, y: 135 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_2": {
        filter: [ "./images/mask/1_2/filter_001.png", "./images/mask/1_2/filter_002.png", "./images/mask/1_2/filter_003.png", "./images/mask/1_2/filter_004.png" ],
        point: [ { x: 90, y: 108 },
                 { x: 85, y: 120 },
                 { x: 135, y: 120 },
                 { x: 160, y: 140 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_3": {
        filter: [ "./images/mask/1_3/filter_001.png", "./images/mask/1_3/filter_002.png", "./images/mask/1_3/filter_003.png", "./images/mask/1_3/filter_004.png", "./images/mask/1_3/filter_005.png" ],
        point: [ { x: 78, y: 75 },
                 { x: 78, y: 95 },
                 { x: 160, y: 110 },
                 { x: 160, y: 120 },
                 { x: 160, y: 155 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_4": {
        filter: [ "./images/mask/1_4/filter_001.png", "./images/mask/1_4/filter_002.png", "./images/mask/1_4/filter_003.png", "./images/mask/1_4/filter_004.png", "./images/mask/1_4/filter_005.png" ],
        point: [ { x: 87, y: 60 },
                 { x: 75, y: 62 },
                 { x: 180, y: 110 },
                 { x: 160, y: 105 },
                 { x: 130, y: 135 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_5": {
        filter: [ "./images/mask/1_5/filter_001.png", "./images/mask/1_5/filter_002.png", "./images/mask/1_5/filter_003.png", "./images/mask/1_5/filter_004.png", "./images/mask/1_5/filter_005.png" ],
        point: [ { x: 65, y: 65 },
                 { x: 68, y: 85 },
                 { x: 158, y: 115 },
                 { x: 170, y: 145 },
                 { x: 142, y: 145 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_6": {
        filter: [ "./images/mask/1_6/filter_001.png", "./images/mask/1_6/filter_002.png", "./images/mask/1_6/filter_003.png" ],
        point: [ { x: 90, y: 105 },
                 { x: 115, y: 120 },
                 { x: 128, y: 128 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_7": {
        filter: [ "./images/mask/1_7/filter_001.png", "./images/mask/1_7/filter_002.png", "./images/mask/1_7/filter_003.png" ],
        point: [ { x: 90, y: 110 },
                 { x: 115, y: 125 },
                 { x: 140, y: 135 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_8": {
        filter: [ "./images/mask/1_8/filter_001.png", "./images/mask/1_8/filter_002.png", "./images/mask/1_8/filter_003.png", "./images/mask/1_8/filter_004.png" ],
        point: [ { x: 100, y: 115 },
                 { x: 140, y: 120 },
                 { x: 100, y: 122 },
                 { x: 135, y: 125 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_9": {
        filter: [ "./images/mask/1_9/filter_001.png", "./images/mask/1_9/filter_002.png", "./images/mask/1_9/filter_003.png", "./images/mask/1_9/filter_004.png" ],
        point: [ { x: 120, y: 98 },
                 { x: 130, y: 125 },
                 { x: 105, y: 105 },
                 { x: 115, y: 138 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_10": {
        filter: [ "./images/mask/1_10/filter_001.png", "./images/mask/1_10/filter_002.png", "./images/mask/1_10/filter_003.png" ],
        point: [ { x: 120, y: 115 },
                 { x: 145, y: 145 },
                 { x: 130, y: 160 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_11": {
        filter: [ "./images/mask/1_11/filter_001.png", "./images/mask/1_11/filter_002.png", "./images/mask/1_11/filter_003.png" ],
        point: [ { x: 105, y: 100 },
                 { x: 130, y: 150 },
                 { x: 130, y: 130 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_12": {
        filter: [ "./images/mask/1_12/filter_001.png", "./images/mask/1_12/filter_002.png", "./images/mask/1_12/filter_003.png" ],
        point: [ { x: 100, y: 110 },
                 { x: 100, y: 120 },
                 { x: 160, y: 135 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_13": {
        filter: [ "./images/mask/1_13/filter_001.png", "./images/mask/1_13/filter_002.png", "./images/mask/1_13/filter_003.png", "./images/mask/1_13/filter_004.png" ],
        point: [ { x: 110, y: 110 },
                 { x: 130, y: 105 },
                 { x: 130, y: 135 },
                 { x: 110, y: 140 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_14": {
        filter: [ "./images/mask/1_14/filter_001.png", "./images/mask/1_14/filter_002.png", "./images/mask/1_14/filter_003.png" ],
        point: [ { x: 115, y: 115 },
                 { x: 135, y: 115 },
                 { x: 128, y: 130 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_15": {
        filter: [ "./images/mask/1_15/filter_001.png", "./images/mask/1_15/filter_002.png", "./images/mask/1_15/filter_003.png" ],
        point: [ { x: 125, y: 130 },
                 { x: 145, y: 120 },
                 { x: 110, y: 145 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_16": {
        filter: [ "./images/mask/1_16/filter_001.png", "./images/mask/1_16/filter_002.png", "./images/mask/1_16/filter_003.png", "./images/mask/1_16/filter_004.png" ],
        point: [ { x: 128, y: 90 },
                 { x: 130, y: 130 },
                 { x: 120, y: 110 },
                 { x: 122, y: 145 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_17": {
        filter: [ "./images/mask/1_17/filter_001.png", "./images/mask/1_17/filter_002.png", "./images/mask/1_17/filter_003.png" ],
        point: [ { x: 145, y: 110 },
                 { x: 120, y: 110 },
                 { x: 110, y: 130 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_18": {
        filter: [ "./images/mask/1_18/filter_001.png", "./images/mask/1_18/filter_002.png", "./images/mask/1_18/filter_003.png", "./images/mask/1_18/filter_004.png" ],
        point: [ { x: 140, y: 110 },
                 { x: 100, y: 110 },
                 { x: 95, y: 120 },
                 { x: 130, y: 125 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_19": {
        filter: [ "./images/mask/1_19/filter_001.png", "./images/mask/1_19/filter_002.png", "./images/mask/1_19/filter_003.png", "./images/mask/1_19/filter_004.png" ],
        point: [ { x: 146, y: 96 },
                 { x: 100, y: 135 },
                 { x: 145, y: 130 },
                 { x: 135, y: 140 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_20": {
        filter: [ "./images/mask/1_20/filter_001.png", "./images/mask/1_20/filter_002.png", "./images/mask/1_20/filter_003.png" ],
        point: [ { x: 110, y: 105 },
                 { x: 140, y: 135 },
                 { x: 100, y: 135 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_21": {
        filter: [ "./images/mask/1_21/filter_001.png", "./images/mask/1_21/filter_002.png", "./images/mask/1_21/filter_003.png", "./images/mask/1_21/filter_004.png" ],
        point: [ { x: 130, y: 110 },
                 { x: 115, y: 115 },
                 { x: 135, y: 148 },
                 { x: 115, y: 148 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_22": {
        filter: [ "./images/mask/1_22/filter_001.png", "./images/mask/1_22/filter_002.png", "./images/mask/1_22/filter_003.png", "./images/mask/1_22/filter_004.png" ],
        point: [ { x: 150, y: 105 },
                 { x: 85, y: 120 },
                 { x: 135, y: 130 },
                 { x: 95, y: 115 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_23": {
        filter: [ "./images/mask/1_23/filter_001.png", "./images/mask/1_23/filter_002.png", "./images/mask/1_23/filter_003.png" ],
        point: [ { x: 130, y: 110 },
                 { x: 135, y: 135 },
                 { x: 90, y: 128 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_24": {
        filter: [ "./images/mask/1_24/filter_001.png", "./images/mask/1_24/filter_002.png", "./images/mask/1_24/filter_003.png" ],
        point: [ { x: 120, y: 90 },
                 { x: 115, y: 140 },
                 { x: 125, y: 140 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_25": {
        filter: [ "./images/mask/1_25/filter_001.png", "./images/mask/1_25/filter_002.png", "./images/mask/1_25/filter_003.png" ],
        point: [ { x: 158, y: 128 },
                 { x: 155, y: 138 },
                 { x: 143, y: 143 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_26": {
        filter: [ "./images/mask/1_26/filter_001.png", "./images/mask/1_26/filter_002.png", "./images/mask/1_26/filter_003.png" ],
        point: [ { x: 158, y: 105 },
                 { x: 145, y: 138 },
                 { x: 110, y: 132 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_27": {
        filter: [ "./images/mask/1_27/filter_001.png", "./images/mask/1_27/filter_002.png", "./images/mask/1_27/filter_003.png", "./images/mask/1_27/filter_004.png" ],
        point: [ { x: 150, y: 115 },
                 { x: 145, y: 125 },
                 { x: 105, y: 115 },
                 { x: 120, y: 125 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_28": {
        filter: [ "./images/mask/1_28/filter_001.png", "./images/mask/1_28/filter_002.png", "./images/mask/1_28/filter_003.png", "./images/mask/1_28/filter_004.png" ],
        point: [ { x: 150, y: 143 },
                 { x: 115, y: 128 },
                 { x: 115, y: 135 },
                 { x: 93, y: 90 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_29": {
        filter: [ "./images/mask/1_29/filter_001.png", "./images/mask/1_29/filter_002.png", "./images/mask/1_29/filter_003.png" ],
        point: [ { x: 105, y: 118 },
                 { x: 120, y: 125 },
                 { x: 158, y: 115 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_30": {
        filter: [ "./images/mask/1_30/filter_001.png", "./images/mask/1_30/filter_002.png", "./images/mask/1_30/filter_003.png" ],
        point: [ { x: 110, y: 128 },
                 { x: 115, y: 130 },
                 { x: 160, y: 120 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_31": {
        filter: [ "./images/mask/1_31/filter_001.png", "./images/mask/1_31/filter_002.png", "./images/mask/1_31/filter_003.png" ],
        point: [ { x: 100, y: 120 },
                 { x: 115, y: 125 },
                 { x: 150, y: 110 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_32": {
        filter: [ "./images/mask/1_32/filter_001.png", "./images/mask/1_32/filter_002.png", "./images/mask/1_32/filter_003.png", "./images/mask/1_32/filter_004.png" ],
        point: [ { x: 140, y: 120 },
                 { x: 135, y: 125 },
                 { x: 110, y: 120 },
                 { x: 100, y: 125 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_33": {
        filter: [ "./images/mask/1_33/filter_001.png", "./images/mask/1_33/filter_002.png", "./images/mask/1_33/filter_003.png", "./images/mask/1_33/filter_004.png" ],
        point: [ { x: 156, y: 115 },
                 { x: 105, y: 140 },
                 { x: 115, y: 120 },
                 { x: 145, y: 140 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_34": {
        filter: [ "./images/mask/1_34/filter_001.png", "./images/mask/1_34/filter_002.png", "./images/mask/1_34/filter_003.png" ],
        point: [ { x: 115, y: 110 },
                 { x: 100, y: 138 },
                 { x: 145, y: 138 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_35": {
        filter: [ "./images/mask/1_35/filter_001.png", "./images/mask/1_35/filter_002.png", "./images/mask/1_35/filter_003.png" ],
        point: [ { x: 105, y: 120 },
                 { x: 140, y: 120 },
                 { x: 125, y: 120 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_36": {
        filter: [ "./images/mask/1_36/filter_001.png", "./images/mask/1_36/filter_002.png", "./images/mask/1_36/filter_003.png", "./images/mask/1_36/filter_004.png" ],
        point: [ { x: 85, y: 115 },
                 { x: 135, y: 115 },
                 { x: 155, y: 115 },
                 { x: 120, y: 130 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "1_37": {
        filter: ["./images/mask/1_37/filter_001.png", "./images/mask/1_37/filter_002.png", "./images/mask/1_37/filter_003.png"],
        point: [ { x: 105, y: 85 },
            { x: 150, y: 115 },
            { x: 110, y: 130 }],
        match: 0.60,
        dis_match: 0.60
    },
    "1_38": {
        filter: ["./images/mask/1_38/filter_001.png", "./images/mask/1_38/filter_002.png", "./images/mask/1_38/filter_003.png", "./images/mask/1_38/filter_004.png"],
        point: [ { x: 90,  y: 135 },
            { x: 105, y: 110 },
            { x: 150, y: 118 },
            { x: 120, y: 135 }],
        match: 0.60,
        dis_match: 0.60
    },


    "2_1": {
        filter: [ "./images/mask/2_1/filter_001.png", "./images/mask/2_1/filter_002.png", "./images/mask/2_1/filter_003.png"],
        point: [ { x: 130, y: 90 },
                 { x: 130, y: 128 },
                 { x: 115, y: 158 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "2_2": {
        filter: [ "./images/mask/2_2/filter_001.png", "./images/mask/2_2/filter_002.png", "./images/mask/2_2/filter_003.png", "./images/mask/2_2/filter_004.png" ],
        point: [ { x: 110, y: 105 },
                 { x: 96, y: 118 },
                 { x: 145, y: 120 },
                 { x: 158, y: 135 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "2_3": {
        filter: [ "./images/mask/2_3/filter_001.png", "./images/mask/2_3/filter_002.png", "./images/mask/2_3/filter_003.png", "./images/mask/2_3/filter_004.png", "./images/mask/2_3/filter_005.png" ],
        point: [ { x: 68, y: 115 },
                 { x: 85, y: 150 },
                 { x: 150, y: 75 },
                 { x: 190, y: 142 },
                 { x: 165, y: 135 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "2_4": {
        filter: [ "./images/mask/2_4/filter_001.png", "./images/mask/2_4/filter_002.png", "./images/mask/2_4/filter_003.png", "./images/mask/2_4/filter_004.png", "./images/mask/2_4/filter_005.png" ],
        point: [ { x: 78, y: 60 },
                 { x: 75, y: 90 },
                 { x: 165, y: 90 },
                 { x: 145, y: 145 },
                 { x: 170, y: 145 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "2_5": {
        filter: [ "./images/mask/2_5/filter_001.png", "./images/mask/2_5/filter_002.png", "./images/mask/2_5/filter_003.png", "./images/mask/2_5/filter_004.png", "./images/mask/2_5/filter_005.png" ],
        point: [ { x: 50, y: 68 },
                 { x: 68, y: 68 },
                 { x: 178, y: 115 },
                 { x: 140, y: 135 },
                 { x: 140, y: 110 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "2_6": {
        filter: [ "./images/mask/2_6/filter_001.png", "./images/mask/2_6/filter_002.png", "./images/mask/2_6/filter_003.png", "./images/mask/2_6/filter_004.png" ],
        point: [ { x: 140, y: 120 },
                 { x: 100, y: 120 },
                 { x: 100, y: 140 },
                 { x: 135, y: 145 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "2_7": {
        filter: [ "./images/mask/2_7/filter_001.png", "./images/mask/2_7/filter_002.png", "./images/mask/2_7/filter_003.png", "./images/mask/2_7/filter_004.png" ],
        point: [ { x: 110, y: 118 },
                 { x: 135, y: 118 },
                 { x: 100, y: 145 },
                 { x: 140, y: 145 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "2_8": {
        filter: [ "./images/mask/2_8/filter_001.png", "./images/mask/2_8/filter_002.png", "./images/mask/2_8/filter_003.png" ],
        point: [ { x: 145, y: 100 },
                 { x: 105, y: 125 },
                 { x: 120, y: 135 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "2_9": {
        filter: [ "./images/mask/2_9/filter_001.png", "./images/mask/2_9/filter_002.png", "./images/mask/2_9/filter_003.png" ],
        point: [ { x: 140, y: 105 },
                 { x: 115, y: 125 },
                 { x: 85, y: 145 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "2_10": {
        filter: [ "./images/mask/2_10/filter_001.png", "./images/mask/2_10/filter_002.png", "./images/mask/2_10/filter_003.png", "./images/mask/2_10/filter_004.png" ],
        point: [ { x: 125, y: 95 },
                 { x: 105, y: 145 },
                 { x: 135, y: 145 },
                 { x: 115, y: 155 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "2_11": {
        filter: [ "./images/mask/2_11/filter_001.png", "./images/mask/2_11/filter_002.png", "./images/mask/2_11/filter_003.png", "./images/mask/2_11/filter_004.png" ],
        point: [ { x: 150, y: 108 },
                 { x: 95, y: 110 },
                 { x: 100, y: 127 },
                 { x: 138, y: 128 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "2_12": {
        filter: [ "./images/mask/2_12/filter_001.png", "./images/mask/2_12/filter_002.png", "./images/mask/2_12/filter_003.png", "./images/mask/2_12/filter_004.png" ],
        point: [ { x: 145, y: 105 },
                 { x: 90, y: 135 },
                 { x: 100, y: 105 },
                 { x: 135, y: 130 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "2_13": {
        filter: [ "./images/mask/2_13/filter_001.png", "./images/mask/2_13/filter_002.png", "./images/mask/2_13/filter_003.png" ],
        point: [ { x: 110, y: 95 },
                 { x: 140, y: 140 },
                 { x: 125, y: 140 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "2_14": {
        filter: [ "./images/mask/2_14/filter_001.png", "./images/mask/2_14/filter_002.png", "./images/mask/2_14/filter_003.png", "./images/mask/2_14/filter_004.png" ],
        point: [ { x: 148, y: 110 },
                 { x: 100, y: 120 },
                 { x: 95, y: 138 },
                 { x: 145, y: 135 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "2_15": {
        filter: [ "./images/mask/2_15/filter_001.png", "./images/mask/2_15/filter_002.png", "./images/mask/2_15/filter_003.png", "./images/mask/2_15/filter_004.png" ],
        point: [ { x: 148, y: 105 },
                 { x: 95, y: 115 },
                 { x: 145, y: 128 },
                 { x: 102, y: 122 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "2_16": {
        filter: [ "./images/mask/2_16/filter_001.png", "./images/mask/2_16/filter_002.png", "./images/mask/2_16/filter_003.png" ],
        point: [ { x: 130, y: 95 },
                 { x: 105, y: 145 },
                 { x: 130, y: 135 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "2_17": {
        filter: [ "./images/mask/2_17/filter_001.png", "./images/mask/2_17/filter_002.png", "./images/mask/2_17/filter_003.png" ],
        point: [ { x: 145, y: 135 },
                 { x: 105, y: 110 },
                 { x: 95, y: 135 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "2_18": {
        filter: [ "./images/mask/2_18/filter_001.png", "./images/mask/2_18/filter_002.png", "./images/mask/2_18/filter_003.png", "./images/mask/2_18/filter_004.png" ],
        point: [ { x: 142, y: 100 },
                 { x: 95, y: 135 },
                 { x: 128, y: 128 },
                 { x: 124, y: 124 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "2_19": {
        filter: [ "./images/mask/2_19/filter_001.png", "./images/mask/2_19/filter_002.png", "./images/mask/2_19/filter_003.png", "./images/mask/2_19/filter_004.png" ],
        point: [ { x: 103, y: 100 },
                 { x: 148, y: 140 },
                 { x: 110, y: 135 },
                 { x: 120, y: 125 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "2_20": {
        filter: [ "./images/mask/2_20/filter_001.png", "./images/mask/2_20/filter_002.png", "./images/mask/2_20/filter_003.png", "./images/mask/2_20/filter_004.png" ],
        point: [ { x: 85, y: 110 },
                 { x: 145, y: 115 },
                 { x: 100, y: 125 },
                 { x: 145, y: 125 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "2_21": {
        filter: [ "./images/mask/2_21/filter_001.png", "./images/mask/2_21/filter_002.png", "./images/mask/2_21/filter_003.png" ],
        point: [ { x: 150, y: 135 },
                 { x: 100, y: 115 },
                 { x: 107, y: 148 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "2_22": {
        filter: [ "./images/mask/2_22/filter_001.png", "./images/mask/2_22/filter_002.png", "./images/mask/2_22/filter_003.png" ],
        point: [ { x: 145, y: 110 },
                 { x: 90, y: 120 },
                 { x: 115, y: 135 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "2_23": {
        filter: [ "./images/mask/2_23/filter_001.png", "./images/mask/2_23/filter_002.png", "./images/mask/2_23/filter_003.png", "./images/mask/2_23/filter_004.png" ],
        point: [ { x: 150, y: 95 },
                 { x: 110, y: 125 },
                 { x: 105, y: 130 },
                 { x: 135, y: 125 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "2_24": {
        filter: [ "./images/mask/2_24/filter_001.png", "./images/mask/2_24/filter_002.png", "./images/mask/2_24/filter_003.png", "./images/mask/2_24/filter_004.png" ],
        point: [ { x: 140, y: 100 },
                 { x: 100, y: 145 },
                 { x: 130, y: 140 },
                 { x: 118, y: 155 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "2_25": {
        filter: [ "./images/mask/2_25/filter_001.png", "./images/mask/2_25/filter_002.png", "./images/mask/2_25/filter_003.png" ],
        point: [ { x: 110, y: 105 },
                 { x: 110, y: 125 },
                 { x: 150, y: 125 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "2_26": {
        filter: [ "./images/mask/2_26/filter_001.png", "./images/mask/2_26/filter_002.png", "./images/mask/2_26/filter_003.png", "./images/mask/2_26/filter_003.png" ],
        point: [ { x: 90, y: 90 },
                 { x: 115, y: 130 },
                 { x: 130, y: 130 },
                 { x: 142, y: 142 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "2_27": {
        filter: [ "./images/mask/2_27/filter_001.png", "./images/mask/2_27/filter_002.png", "./images/mask/2_27/filter_003.png", "./images/mask/2_27/filter_003.png" ],
        point: [ { x: 95, y: 110 },
                 { x: 145, y: 110 },
                 { x: 110, y: 135 },
                 { x: 140, y: 125 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "2_28": {
        filter: [ "./images/mask/2_26/filter_001.png", "./images/mask/2_26/filter_002.png", "./images/mask/2_26/filter_003.png", "./images/mask/2_26/filter_003.png" ],
        point: [ { x: 125, y: 105 },
                 { x: 155, y: 120 },
                 { x: 80, y: 130 },
                 { x: 120, y: 130 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "2_29": {
        filter: [ "./images/mask/2_29/filter_001.png", "./images/mask/2_29/filter_002.png", "./images/mask/2_29/filter_003.png" ],
        point: [ { x: 120, y: 100 },
                 { x: 135, y: 125 },
                 { x: 100, y: 125 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "2_30": {
        filter: [ "./images/mask/2_30/filter_001.png", "./images/mask/2_30/filter_002.png", "./images/mask/2_30/filter_003.png", "./images/mask/2_30/filter_004.png" ],
        point: [ { x: 140, y: 110 },
                 { x: 110, y: 110 },
                 { x: 100, y: 140 },
                 { x: 135, y: 135 } ],
        match: 0.60,
        dis_match: 0.60
    },
    "2_31": {
        filter: [ "./images/mask/2_31/filter_001.png", "./images/mask/2_31/filter_002.png", "./images/mask/2_31/filter_003.png", "./images/mask/2_31/filter_004.png" ],
        point: [ { x: 120, y: 155 },
                 { x: 140, y: 105 },
                 { x:  90, y: 105 },
                 { x: 120, y: 110 } ],
        match: 0.60,
        dis_match: 0.60
    },
};
exports.objCountList = [38, 31];
exports.isInited = false;

exports.setCookie = function(key, value){
    localStorage.setItem(keyPrefix + key, value);
}

exports.getCookie = function(key){
    return localStorage.getItem(keyPrefix + key);
}
exports.removeCookie = function(key){
    localStorage.removeItem(keyPrefix + key);
}
exports.loadFoundList = function(){

    let foundModelList = this.getCookie("found_model");
    if(foundModelList === undefined){
        foundModelList = false;
    }else{
        foundModelList = JSON.parse(foundModelList);
    }
    if(!Array.isArray(foundModelList)){
        foundModelList = [];
        for( var j = 0;j < this.objCountList.length;j++ ){
            foundModelList[j] = [];
            for( var i = 0;i < this.objCountList[j];i++ ){
                foundModelList[j][i] = false;
            }
        }
    }
    this.setCookie( "found_model", JSON.stringify(foundModelList) );

    return foundModelList;
}
exports.getMaskData = function(id){
    if( id in maskImages ){
        return maskImages[id];
    }
    return null;
}

exports.init = function(){

    exports.isInited = true;
}